export default __webpack_public_path__ + "static/media/Omen_artwork.7f472438.png";